export enum TipsPart {
    title = 'title',
    locationAndWorkplace = 'locationAndWorkplace',
    tags = 'tags',
    price = 'price',
    phone = 'phone',
    languages = 'languages',
}
